import React from "react";
import "./css/index.css";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { Oval } from "react-loader-spinner";

const Loading = ({ initialLoading }: { initialLoading?: boolean }) => {
  const isLoading = useSelector<RootState, boolean>(
    (state) => state.config.isLoading
  );
  return isLoading || initialLoading ? (
    <div className="loading-section">
      <div className="back-black" />
      <Oval
        width={100}
        height={100}
        color="var(--main)"
        secondaryColor="#fffff"
      />
    </div>
  ) : (
    <></>
  );
};

export default Loading;
